var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75625 9.7373L10.1375 13.9873H14.6062L10.9937 16.6186L12.375 20.8686L8.75625 18.2436L5.1375 20.8686L6.525 16.6186L2.90625 13.9873H7.375L8.75625 9.7373Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9688 24.7812L17.9125 23.4812L16.35 24.0874L17.2563 22.6812L16.2 21.3749L17.8188 21.8062L18.7313 20.3999L18.8188 22.0749L20.4438 22.5062L18.875 23.1062L18.9688 24.7812Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0688 20.9687L21.5688 19.3687L20.2 18.3999L21.875 18.3749L22.3688 16.7749L22.9125 18.3624L24.5875 18.3437L23.2438 19.3437L23.7813 20.9312L22.4125 19.9624L21.0688 20.9687Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 11.7437L23.1625 13.25L24.3625 14.4187L22.7062 14.1812L21.9687 15.6812L21.6812 14.0312L20.0187 13.7937L21.5062 13.0125L21.2187 11.3562L22.4187 12.525L23.9 11.7437Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0129 7.18115L18.8879 8.8499L20.4441 9.48115L18.8129 9.88115L18.6941 11.5562L17.8129 10.1312L16.1816 10.5312L17.2629 9.2499L16.3754 7.83115L17.9316 8.4624L19.0129 7.18115Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagChina);
export default __webpack_public_path__ + "static/media/flag_china.e709896eca1de5fc82f711487714f5e8.svg";
export { ForwardRef as ReactComponent };